import { format } from "date-fns";

const padNumber = (val: number) => {
  const value = (val || "").toString();

  if (value.length === 1) {
    return `0${value}`;
  }

  return value;
};

export const formatDate = (
  date: {
    year: number;
    month: number;
    day: number;
  },
  dateFormat: string = "yyy-MM-dd",
) => {
  try {
    if (!date || date.year === 1900) return "";

    const d = new Date(`${date.month}/${date.day}/${date.year} 10:00 UTC`);

    return format(d, dateFormat);
  } catch (err) {
    const e = err as Error;
    console.error(e.message);
    return "";
  }
};

export const dateStrToObj = (dateStr: string) => {
  const parts = (dateStr || "").split("-");
  return {
    year: Number(parts[0]) || 0,
    month: Number(parts[1]) || 0,
    day: Number(parts[2]) || 0,
  };
};

export const formatDateTime = (
  date: {
    year: number;
    month: number;
    day: number;
    hour: number;
    minute: number;
    second: number;
    nanosecond: number;
  },
  datetimeFormat: string = "yyyy-MM-dd h:mm aa",
) => {
  try {
    if (!date || date.year === 1900) return "";

    const d = new Date(
      `${date.month}/${date.day}/${date.year} ${date.hour}:${padNumber(
        date.minute,
      )} UTC`,
    );

    return format(d, datetimeFormat);
  } catch (err) {
    const e = err as Error;
    console.error(e.message);
    return "";
  }
};
